// extracted by mini-css-extract-plugin
export default {"value":"MicropileParametersSection_value__8KxCX","wrapper":"MicropileParametersSection_wrapper__dkZJB"};